import { Grid, Typography } from '@mui/material';
import { CheckboxItem } from 'lib/designSystem/CheckBoxItem';
import React from 'react';

import {
  ConfirmingCheckboxesSetters,
  ConfirmingCheckboxesState,
} from '../hooks/useConfirmingCheckboxes';
import { CheckboxWithButton } from './CheckboxWithButton';

interface ConfirmingCheckboxesProps {
  checkboxes: ConfirmingCheckboxesState;
  setters: ConfirmingCheckboxesSetters;
  onChatButtonClick?: () => void;
  onChatAsObservationsChange?: (checked: boolean) => void;
}

export const ConfirmingCheckboxes: React.FC<ConfirmingCheckboxesProps> = ({
  checkboxes,
  setters,
  onChatButtonClick,
  onChatAsObservationsChange,
}) => {
  const {
    showClientInfo,
    showRequestInfo,
    showDates,
    showAdvance,
    showRate,
    showArrearRate,
    showAmounts,
    showDocuments,
    showOperationCosts,
    showExpenses,
    showAccountReceivable,
    showChatAsObservations,
    selectedChatMessages,
  } = checkboxes;

  const {
    setShowClientInfo,
    setShowRequestInfo,
    setShowDates,
    setShowAdvance,
    setShowRate,
    setShowArrearRate,
    setShowAmounts,
    setShowDocuments,
    setShowOperationCosts,
    setShowExpenses,
    setShowAccountReceivable,
    setShowChatAsObservations,
  } = setters;

  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 'bold', mb: 1, mt: 2 }}
        >
          Información del Cliente
        </Typography>
        <CheckboxItem
          label="Información del cliente"
          checked={showClientInfo}
          onChange={setShowClientInfo}
        />
        <CheckboxItem
          label="Información de la solicitud"
          checked={showRequestInfo}
          onChange={setShowRequestInfo}
        />
        <CheckboxItem
          label="Fechas de operación"
          checked={showDates}
          onChange={setShowDates}
        />
      </Grid>
      <Grid item xs={4}>
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 'bold', mb: 1, mt: 2 }}
        >
          Tasas y Parámetros
        </Typography>
        <CheckboxItem
          label="Anticipo"
          checked={showAdvance}
          onChange={setShowAdvance}
        />
        <CheckboxItem
          label="Diferencia de precio"
          checked={showRate}
          onChange={setShowRate}
        />
        <CheckboxItem
          label="Tasa de mora"
          checked={showArrearRate}
          onChange={setShowArrearRate}
        />
      </Grid>
      <Grid item xs={4}>
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 'bold', mb: 1, mt: 2 }}
        >
          Detalles de la Operación
        </Typography>
        <CheckboxItem
          label="Montos principales"
          checked={showAmounts}
          onChange={setShowAmounts}
        />
        <CheckboxItem
          label="Tabla de documentos"
          checked={showDocuments}
          onChange={setShowDocuments}
        />
        <CheckboxItem
          label="Costos de operación"
          checked={showOperationCosts}
          onChange={setShowOperationCosts}
        />
        <CheckboxItem
          label="Gastos adicionales"
          checked={showExpenses}
          onChange={setShowExpenses}
        />
        <CheckboxItem
          label="Cuenta por cobrar"
          checked={showAccountReceivable}
          onChange={setShowAccountReceivable}
        />
        <CheckboxWithButton
          label="Chat como observaciones"
          checked={showChatAsObservations}
          onChange={onChatAsObservationsChange || setShowChatAsObservations}
          chipCount={selectedChatMessages.length}
          onButtonClick={onChatButtonClick || (() => {})}
          buttonDisabled={!showChatAsObservations}
        />
      </Grid>
    </Grid>
  );
};
